


export const formatDisplayDate = (isoDateString: string) => {
    const date = new Date(isoDateString);
    const now = new Date();
  
    const isToday = date.toDateString() === now.toDateString();
  
    const yesterday = new Date();
    yesterday.setDate(now.getDate() - 1);
    const isYesterday = date.toDateString() === yesterday.toDateString();
  
    const diffInDays = Math.floor((now.getTime() - date.getTime()) / (1000 * 60 * 60 * 24));
  
    if (isToday) return 'Today';
    if (isYesterday) return 'Yesterday';
    if (diffInDays < 7) {
      return date.toLocaleDateString('en-US', { weekday: 'long' }); // e.g., "Monday"
    }
  
    return date.toLocaleDateString('en-GB', {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    }); // e.g., "1 May 2025"
  };

export const getRelativeDateLabel = (dateString: string): string => {
  const givenDate = new Date(dateString);
  const today = new Date();
  const yesterday = new Date();
  yesterday.setDate(today.getDate() - 1);

  const formatDate = (date: Date) => {
    const day = String(date.getDate()).padStart(2, '0');
    const month = date.toLocaleString('default', { month: 'short' });
    const year = date.getFullYear();
    return `${day} ${month} ${year}`; // e.g., 14 Aug 2024
  };

  const givenDateStr = givenDate.toISOString().split('T')[0];
  const todayStr = today.toISOString().split('T')[0];
  const yesterdayStr = yesterday.toISOString().split('T')[0];

  if (givenDateStr === todayStr) return 'Today';
  if (givenDateStr === yesterdayStr) return 'Yesterday';
  return formatDate(givenDate);
};
